import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { CaretDownIcon } from '@phosphor-icons/react'

/**
 * A foldable section row shared by the record popover and the live recording
 * panel: label, a one-line summary while folded, a chevron, and optional
 * actions beside the toggle (kept outside it — buttons can't nest).
 */
export function RecordingSectionToggle({
  label,
  summary,
  open,
  onToggle,
  actions,
  className,
}: {
  label: string
  summary?: string
  open: boolean
  onToggle: () => void
  actions?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex shrink-0 items-center', className)}>
      <button
        type="button"
        aria-expanded={open}
        onClick={onToggle}
        className="flex min-w-0 flex-1 items-center gap-2 px-4 py-2.5 text-left transition-colors hover:bg-muted/50 focus-visible:bg-muted/50 focus-visible:outline-none"
      >
        <span className="shrink-0 text-xs font-medium text-muted-foreground">
          {label}
        </span>
        {summary && !open && (
          <span className="ml-auto min-w-0 truncate text-xs text-foreground/80">
            {summary}
          </span>
        )}
        <CaretDownIcon
          className={cn(
            'h-3.5 w-3.5 shrink-0 text-muted-foreground transition-transform',
            (!summary || open) && 'ml-auto',
            open && 'rotate-180',
          )}
          aria-hidden
        />
      </button>
      {actions && (
        <div className="flex shrink-0 items-center gap-1 pr-2">{actions}</div>
      )}
    </div>
  )
}
